<template>
  <div class="volunteer-detail-wrapper">
    <div class="p-top-wrapper">
      <div class="p-top">
        <div class="p-left" @click="backHome">
          <img :src="require('@/assets/img/common/back_home@2x.png')" alt="" class="p-image-home" />
          <div class="p-backtips">返回首页</div>
        </div>
        <div class="p-arrow-tips"> > </div>
        <div class="p-backtips" @click="$router.push('/voluntary-activites')">志愿活动</div>
        <div class="p-arrow-tips"> > </div>
        <div class="p-map-tips" >{{ detailContent.name }}</div>
      </div>
    </div>

    <div class="volunteer-detail">
      <div class="volunteer-detail-left">
        <div class="volunteer-detail-left-top">
          <div class="vdl-img">
            <img :src="require('@/assets/img/volunteer/zyava.jpeg')" alt="" v-if="detailContent.thumb==null ">
            <img :src="require('@/assets/img/volunteer/zyava.jpeg')" alt="" v-if="detailContent.thumb=='' ">
            <img :src="detailContent.thumb" alt="" v-else>
          </div>
          <div class="vdl-title">
            {{ detailContent.name }}
          </div>
          <div class="vdl-time-num">
            <div class="vdl-time-num" v-if="actStatus==0">
              暂未开始
            </div>
            <div class="vdl-time-num" v-if="actStatus==1">
              剩余 <p>{{remainingTime}}</p>截止
            </div>
            <div class="vdl-time-num" v-if="actStatus==2">
              已截止
            </div>
            <div class="vdl-time-num">
              已报名：<p>{{ detailContent.signup_people }}</p>/{{ detailContent.recruit_people }}人
            </div>
          </div>
          <div class="comein-orginize" @click="toSignUp" v-if="detailContent.is_signup == 0">我要参加</div>
          <a-popconfirm
              title="确认取消报名吗？"
              ok-text="是"
              cancel-text="否"
              @confirm="toCancleSign"
          >
            <div class="comein-orginize"  v-if="detailContent.is_signup == 1">取消报名</div>
          </a-popconfirm>


        </div>
        <div class="comein-volunteer">
          <div class="comein-volunteer-top">
            <img src="../../../assets/img/volunteer/people.png" alt="">
            <p>报名志愿者</p>
          </div>
          <div class="comein-volunteer-people" v-if="detailContent.users && detailContent.users.length>0" >
            <div v-for="(item1,index1) in detailContent.users" :key="index1" class="comein-volunteer-people-item">
              <img :src="item1.avatar?item1.avatar:require('../../../assets/img/user/icon_headImage@2x.png')" alt="">
              <p>{{item1.qianTime}}</p>
            </div>
          </div>
          <div  v-else>
            <p class="nodata">
              暂无数据，快去报名参加吧！
            </p>
          </div>
        </div>
      </div>
      <div class="volunteer-detail-right">
        <div class="vdr-top">
          <div class="vdr-top-item">活动地址：{{detailContent.address}}</div>
          <div class="vdr-top-item">活动时间：{{ time }}</div>
          <div class="vdr-top-item">活动类型：{{ detailContent.category }}</div>
          <div class="vdr-top-item">发起组织：{{ detailContent.department_name }}</div>
          <div class="vdr-top-item">联系人：{{ detailContent.contact }}</div>
          <div class="vdr-top-item">联系电话：{{detailContent.contact_phone}}</div>
        </div>
        <div class="vdr-bottom">
          <div class="vdr-title">
            <img src="../../../assets/img/volunteer/introduce@2x.png" alt="">
            <div class="vdr-title-t">活动详情</div>
          </div>
          <div class="vdr-content" v-html="detailContent.content ">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      detailContent: {
      },
      time:'',
      remainingTime:'',
      actStatus:0,
      actId:'',
      btnDisabled: false,
      zyzid:''

    }
  },
  mounted() {
    this.getParams()
    this.zyzid = localStorage.getItem('jz_vol_zyzid');
    this.getDetail()
  },
  methods: {
    backHome() {
      this.$router.replace({ path: "/" });
    },
    toCancleSign(){
      this.$api.vmsapi
          .recruitCancelSignUp({
            zyzid: this.zyzid,
            id: this.actId,
          }).then(res=>{
            if(res.errCode=='0000'){
              this.$message.info('取消报名成功')
              this.getDetail()
            }
      })

    },
    toSignUp(){
      if(!this.zyzid){
        this.$message.info('您还没有登录哦～')
        this.$router.push('/login')
        return
      }
      if (this.btnDisabled) return
      this.btnDisabled = true
      this.$api.vmsapi
          .recruitSignUp({
            zyzid: this.zyzid,
            id: this.actId,
            sourceid: 'wezy',
          }).then(res=>{
            if (res.errCode == '0000') {
              this.$message.info('您已成功申请成功')
              this.getDetail()
              this.btnDisabled = false
            }

      })
    },
    getParams(){
      console.log(this.$route.params,999);
      this.actId = this.$route.params.id
    },
    getDetail(){
      this.$api.vmsapi.recruitDetail({
        zyzid: this.zyzid,
        id: this.actId
      }).then(res=>{
        console.log(res,888)
        const nowtime = new Date().getTime()
        this.actStatus = 0
        this.time=dayjs(res.recruit_start_time).format('YYYY-MM-DD')+'至'+dayjs(res.recruit_finish_time).format('YYYY-MM-DD')
        if(res.recruit_start_time > nowtime){
          this.remainingTime = '即将开始招募'
        }else if(res.recruit_start_time < nowtime && res.recruit_finish_time > nowtime){
          this.remainingTime = dayjs(res.recruit_finish_time).format('DD'+'天'+'HH'+'小时')
          this.actStatus = 1
        }else if(res.recruit_finish_time < nowtime){
          this.remainingTime = '招募已截止'
          this.actStatus = 2
        }
        console.log(this.time);
        res.users.forEach(item=>{
         item.qianTime = dayjs(item.createTime).format('DD')+'小时前'
        })
        this.detailContent = res

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.p-top-wrapper{
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.p-top {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  margin-bottom: 57px;
  .p-left {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 16px;
    .p-image-home {
      width: 26px;
      height: 26px;
      margin-right: 6px;
    }
  }
  .p-arrow-tips {
    margin: 0 5px;
  }
  .p-map-tips {
    cursor: pointer;
    color: #CD3232;
  }
}

.volunteer-detail-wrapper {
  width: 100%;
  padding-bottom: 50px;
  background: #fbfbfb;
  padding-top: 20px;
}

.volunteer-detail {
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #FFFFFF;
  padding: 30px 30px 50px 30px;
  display: flex;
  flex-direction: row;

  .volunteer-detail-left {
    text-align: left;
    .volunteer-detail-left-top{
      min-height: 390px;
      .vdl-img{
        height: 180px;
        width: 320px;
        display: table-cell;
        vertical-align: middle;
        display: flex;
        align-items: center;
        img{
          max-width: 100%;
          max-height: 100%;
          display: block;
          margin: auto;
        }
      }
    }



    .vdl-title {
      margin-top: 20px;
      font-size: 20px;
      font-family: Helvetica;
      color: #333333;
      line-height: 20px;
    }
    .vdl-time-num{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 20px;
      .vdl-time-num{
        font-size: 14px;
        font-family: Helvetica;
        color: #727384;
        line-height: 14px;
        p{
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #CD3232;
        }
      }

    }

    .comein-orginize {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      width: 320px;
      height: 32px;
      background: #CD3232;
      border-radius: 2px;
      font-size: 14px;
      font-family: Helvetica;
      color: #FFFFFF;
      line-height: 14px;
    }
    .comein-volunteer{
      .nodata{
        width: 100%;
        height: auto;
        padding: 60px;
        text-align: center;
        font-size: 14px;
        color: #727384;
      }
      .comein-volunteer-top{
        display: flex;
        flex-direction: row;
        img{
          width: 15px;
          height: 15px;
        }
        p{
          font-size: 15px;
          font-family: Helvetica;
          color: #333333;
          line-height: 15px;
        }
      }
      .comein-volunteer-people{
        margin-top: 30px;
        display: grid;
        grid-template-columns: repeat(4,80px);
        .comein-volunteer-people-item{
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;
          img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
          p{}

        }
      }
    }
  }

  .volunteer-detail-right {
    margin-left: 80px;
    display: flex;
    flex-direction: column;
    .vdr-top{
      min-height: 390px;
      text-align: left;
      .vdr-top-item{
        margin-bottom: 20px;
        font-size: 14px;
        font-family: Helvetica;
        color: #333333;
      }
    }
    .vdr-bottom{

      .vdr-title {
        display: flex;
        flex-direction: row;

        img {
          width: 15px;
          height: 15px;
          margin-right: 8px;
        }

        .vdr-title-t {
          font-size: 15px;
          font-family: Helvetica;
          color: #333333;
          line-height: 15px;
        }
      }

      .vdr-content {
        padding-right: 10px;
        margin-top: 20px;
        font-size: 14px;
        font-family: Helvetica;
        color: #333333;
        line-height: 24px;
        text-align: left;
      }
    }

  }
}

</style>